<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Permanent Ink</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Jaime Samms</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Beauty is only skin deep, but some marks—and what they represent—are impossible to escape.</p>
<p class="P_Normal">Eric resents his comfortable college life and the restrictions his family’s expectations put on him. Dwayne, his best friend Angel’s cousin, is a pierced and tattooed ex-con trying to rebuild his life. Eric sees only the tattoos and the way Dwayne’s upbringing have dictated his future. It takes a surprising revelation from Angel to force Eric to see past Dwayne’s defenses to the generous heart beneath and to realize it’s time for him to break free of his own instilled beliefs. The men can’t keep apart, and they gradually learn that everything they thought they knew about each other might be wrong.</p>
<p class="P_Normal">Opposites attract as two men from very different backgrounds move from enemies to lovers in a story of understanding, compassion, and redemption.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?5296038c